// 全局选中门店：跨模块共享，避免每个页面重选
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { StoreLite } from '../components/StoreSelector.js';

interface GlobalStoreState {
	currentStoreId: string | null;
	currentStore: StoreLite | null;
	setStore: (id: string, store: StoreLite) => void;
	clearStore: () => void;
	favoriteStoreIds: string[];
	toggleFavorite: (id: string) => void;
	isFavorite: (id: string) => boolean;
}

export const useGlobalStore = create<GlobalStoreState>()(
	persist(
		(set, get) => ({
			currentStoreId: null,
			currentStore: null,
			setStore: (id, store) => set({ currentStoreId: id, currentStore: store }),
			clearStore: () => set({ currentStoreId: null, currentStore: null }),
			favoriteStoreIds: [],
			toggleFavorite: (id) => {
				const cur = get().favoriteStoreIds;
				set({
					favoriteStoreIds: cur.includes(id)
						? cur.filter((x) => x !== id)
						: [...cur, id],
				});
			},
			isFavorite: (id) => get().favoriteStoreIds.includes(id),
		}),
		{ name: 'ulucu-global-store' },
	),
);
